import {StateChanges} from './stateChanges'
import {RunStates} from './runStates'

function gtag () { window.dataLayer.push(arguments) }

const basicMutations = {
  [StateChanges.SET_ENTIRE_STATE] (state, commitObj) {
    this.replaceState(JSON.parse(commitObj.newStateJson))
  },
  [StateChanges.SEARCH_NOT_RUN]: function (state) {
    state.searchApiState = RunStates.NOT_RUN
  },
  [StateChanges.SEARCH_RUNNING] (state) {
    state.searchApiState = RunStates.RUNNING
  },
  [StateChanges.SEARCH_FAILED]: function (state) {
    state.searchApiState = RunStates.FAILED
  },
  [StateChanges.SEARCH_TIMED_OUT]: function (state) {
    state.searchApiState = RunStates.TIMED_OUT
  },
  [StateChanges.SEARCH_COMPLETE]: function (state) {
    state.searchApiState = RunStates.COMPLETE
  },
 
  [StateChanges.SENTENCE_SEARCH_NOT_RUN]: function (state) {
    state.sentenceApiState = RunStates.NOT_RUN
  },
  [StateChanges.SENTENCE_SEARCH_RUNNING] (state) {
    state.sentenceApiState = RunStates.RUNNING
  },
  [StateChanges.SENTENCE_SEARCH_FAILED]: function (state) {
    state.sentenceApiState = RunStates.FAILED
  },
  [StateChanges.SENTENCE_SEARCH_TIMED_OUT]: function (state) {
    state.sentenceApiState = RunStates.TIMED_OUT
  },
  [StateChanges.SENTENCE_SEARCH_COMPLETE]: function (state) {
    state.sentenceApiState = RunStates.COMPLETE
  },
  [StateChanges.TYPE_AHEAD_RUNNING] (state) {
    state.taApiState = RunStates.RUNNING
  },
  [StateChanges.TYPE_AHEAD_FAILED]: function (state) {
    state.taApiState = RunStates.FAILED
  },
  [StateChanges.TYPE_AHEAD_TIMED_OUT]: function (state) {
    state.taApiState = RunStates.TIMED_OUT
  },
  [StateChanges.TYPE_AHEAD_COMPLETE]: function (state) {
    state.taApiState = RunStates.COMPLETE
  },
  [StateChanges.SET_TEXT_FOR_API_CALL]: function (state, newText) {
    state.textForApiCall = newText
  },
  [StateChanges.SET_SENTENCE_TEXT_FOR_API_CALL]: function (state, newText) {
    state.textForApiSentenceCall = newText
    if(newText !== '') {
      gtag('event', 'Word Searched', {
        'event_category': 'selection',
        'event_label': newText
      })
    }
  },
  [StateChanges.SET_BIBLE]: function (state, val) {
    state.showBible = val
  },
  [StateChanges.SET_TALMUD]: function (state, val) {
    state.showTalmud = val
  },
  [StateChanges.SET_TYPE_AHEAD_RESULTS]: function (state, data) {
    state.typeAheadApiResponseBible = data.tanach_results
    state.typeAheadApiResponseTalmud = data.talmud_results
  },
  [StateChanges.SET_SEARCH_RESULTS]: function (state, data) {
    state.totalBibleCount = 0
    state.totalTalmudCount = 0
    state.bibleSearchApiResponse = data.tanach_results.map((segment) => {
      state.totalBibleCount += segment.sentence_count
      const searchObj = {
        word: segment.word,
        sentence_count: segment.sentence_count,
        sentences: []
      }
      return searchObj
    })
    state.talmudSearchApiResponse = data.talmud_results.map((segment) => {
      state.totalTalmudCount += segment.sentence_count
      const searchObj = {
        word: segment.word,
        sentence_count: segment.sentence_count,
        sentences: []        
      }
      return searchObj
    })    
  },
  [StateChanges.SET_CURRENT_INDEX]: function (state, val) {
    state.currentIndex = val
  },
  [StateChanges.SET_SENTENCE_RESULTS]: function (state, data) {
    state.showBible ? state.bibleSearchApiResponse[state.currentIndex].sentences = data :
      state.talmudSearchApiResponse[state.currentIndex].sentences = data 
  },
  [StateChanges.RESET_STATE]: function (state) {    
    state.bibleSearchApiResponse = []
    state.talmudSearchApiResponse = []
    state.typeAheadApiResponseBible = []
    state.typeAheadApiResponseTalmud = []
    state.textForApiCall = ''
    state.searchApiState = RunStates.NOT_RUN
    state.taApiState = RunStates.NOT_RUN
  },
  [StateChanges.RESET_RESULTS]: function (state) {    
    state.bibleSearchApiResponse = []
    state.bibleSearchApiResponse = []
    state.typeAheadApiResponseBible = []
    state.typeAheadApiResponseTalmud = []
    state.searchApiState = RunStates.NOT_RUN
    state.taApiState = RunStates.NOT_RUN
  }
  
}

export default basicMutations
